import React, { useState, useEffect } from 'react';
import Logo from "../../assets/logo.png";
import { Link } from 'react-router-dom';

const Navbar = ({ request }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // check if we are on Datenschutz or Impressum page
  const isStaticPage = request === "datenschutz" || request === "impressum";

  // helper: return correct href depending on page
  const getHref = (id) => isStaticPage ? `/#${id}` : `#${id}`;

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-black' : 'bg-transparent'} py-4`}>
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <a href="/">
            <img src={Logo} alt="Logo" className="w-[8rem] h-24 object-contain" />
          </a>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-white hover:text-blue-500">Startseite</Link>
          <a href={getHref("car-search-section")} className="text-white hover:text-blue-500">Unsere Fahrzeuge</a>
          <a href={getHref("about")} className="text-white hover:text-blue-500">Über uns</a>
          <a
            href={getHref("contact")}
            className="bg-[#0048AE] text-white px-4 py-3 rounded-[25px]"
          >
            Kontaktieren Sie uns
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
            <svg
              className="w-8 h-8"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Full-Screen Menu */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-40 flex items-center justify-center"
          onClick={() => setMenuOpen(false)}
        >
          <div
            className="flex flex-col items-center space-y-8"
            onClick={e => e.stopPropagation()}
          >
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="text-white text-2xl"
            >
              Startseite
            </Link>
            <a
              href={getHref("car-search-section")}
              onClick={() => setMenuOpen(false)}
              className="text-white text-2xl"
            >
              Unsere Fahrzeuge
            </a>
            <a
              href={getHref("about")}
              onClick={() => setMenuOpen(false)}
              className="text-white text-2xl"
            >
              Über uns
            </a>
            <a
              href={getHref("contact")}
              onClick={() => setMenuOpen(false)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-[25px] text-xl"
            >
              Kontaktieren Sie uns
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
